import React from "react";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import TeamAvatar from "./TeamAvatar";
import teamLogoStyles from "../styles/TeamLogoStyles";
import { useTeamsContext } from "../../../state/teams/context";

const TeamLogo = ({
	team,
	hideName,
	teamNameAsDefault,
	teamNamePosition,
	teamNameColor,
	teamNameFontSize,
	size,
	variant,
	showBackgroundColor
}) => {
	const classes = teamLogoStyles({
		teamNamePosition,
		teamNameColor,
		teamNameFontSize
	});
	const { logo, teamName } = team;
	const { state } = useTeamsContext();
	const color = state.teamColor(team);

	return (
		<Box key={`${teamName}-${color}`} className={classes.teamLogoBox}>
			<TeamAvatar
				color={color}
				logo={logo}
				size={size}
				teamName={teamName}
				variant={variant}
				showBackgroundColor={showBackgroundColor}
			/>
			{(!hideName || (!logo && teamNameAsDefault)) && (
				<Typography className={classes.teamLogoTypography}>{teamName}</Typography>
			)}
		</Box>
	);
};

TeamLogo.defaultProps = {
	size: "medium",
	variant: "rounded",
	showBackgroundColor: true,
	teamNamePosition: "bottom",
	teamNameColor: "#5B5B5B",
	teamNameFontSize: "0.875rem"
};

TeamLogo.propTypes = {
	size: PropTypes.oneOf(["small", "medium", "large"]),
	variant: PropTypes.oneOf(["square", "circular", "rounded"]),
	showBackgroundColor: PropTypes.bool,
	teamNamePosition: PropTypes.oneOf(["bottom", "top", "left", "right"]),
	teamNameColor: PropTypes.string,
	teamNameFontSize: PropTypes.string
};

export default TeamLogo;
